export default "__VITE_ASSET__BLLqZ9bY__"